import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import { RdaAuthentication } from "../rdaAuthentication";
import { RdaAuthMobileApp } from "../rdaAuthMobileApp";
import StepperForm from "../StepperForm";
import PrivetRoute from "./PrivateRoute";

export const AppRoutes = () => {
  return (
    <Routes>
      <Route index path="/" element={<RdaAuthentication />}></Route>
      <Route
        path="/mobileauthentication"
        element={<RdaAuthMobileApp />}
      ></Route>
      <Route path="/" exact element={<PrivetRoute />}>
        <Route path="/datainput" element={<StepperForm />} />
      </Route>
    </Routes>
  );
};
